var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPeopleNav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1873 6.41345C10.4562 7.37657 9.2997 8 8 8C5.79436 8 4 6.20564 4 4C4 1.79436 5.79436 0 8 0C9.2997 0 10.4562 0.623426 11.1873 1.58655C11.6968 2.25791 12 3.09406 12 4C12 4.90594 11.6968 5.74209 11.1873 6.41345Z",
    fill: "#908CA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.0769C16 18.5867 15.5328 19 14.9565 19H1.04348C0.4672 19 0 18.5867 0 18.0769C0 14.1747 3.5888 11 8 11C9.24522 11 10.4248 11.2531 11.4767 11.7039C12.2482 12.0347 12.9507 12.4721 13.5603 12.994C14.8277 14.0794 15.6919 15.5309 15.9319 17.1538C15.9766 17.4561 16 17.7641 16 18.0769Z",
    fill: "#908CA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9885 19H20.9565C21.5328 19 22 18.5867 22 18.0769C22 17.7641 21.9766 17.4561 21.9319 17.1538C21.6919 15.5309 20.8277 14.0794 19.5603 12.994C18.9507 12.4721 18.2482 12.0347 17.4767 11.7039C16.4248 11.2531 15.2452 11 14 11C13.5877 11 13.1826 11.0277 12.787 11.0812C13.5791 11.465 14.3063 11.941 14.9503 12.4925C16.5346 13.8492 17.6149 15.6636 17.9149 17.6923C17.9708 18.0701 18 18.4552 18 18.8462C18 18.8983 17.9961 18.9497 17.9885 19Z",
    fill: "#908CA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4C13 5.03522 12.6833 5.99753 12.1423 6.79622C12.8689 7.53863 13.8816 8 15 8C16.2997 8 17.4562 7.37657 18.1873 6.41345C18.6968 5.74209 19 4.90594 19 4C19 3.09406 18.6968 2.25791 18.1873 1.58655C17.4562 0.623426 16.2997 0 15 0C13.8816 0 12.8689 0.461368 12.1423 1.20378C12.6833 2.00247 13 2.96478 13 4Z",
    fill: "#908CA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeopleNav);
export default __webpack_public_path__ + "static/media/icon-people-nav.185697982dd70661c61e7f8b6fe84b49.svg";
export { ForwardRef as ReactComponent };